<template>
  <div class="row">
    <div class="col-12">
      Zarządzanie załącznikiem :<br />

      <post-form
        v-if="attachment"
        class="mt-2"
        text="Pobierz obecny załącznik"
        button-class="btn btn-light"
        icon="fal fa-fw fa-download mr-2"
        :url="downloadLink"
      />

      <file-upload
        class="mt-2"
        add-files-text="Dodaj nowy załącznik"
        :duplicate-check="false"
        :hide-dropzone="true"
        @fileAdded="saveAttachment"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import FileUpload from '@/components/formComponents/FileUpload';
import PostForm from '@/components/postForm/PostForm';
import { AttachmentType } from '@/enums/attachmentType.enum';
import { Errors } from '@/enums/errors.enum';
import { EntityType } from '@/enums/entityType.enum';
import { Successes } from '@/enums/successes.enum';
import { notificationsMixin } from '@/mixins/notifications';
import { config } from '@/utils/config';

// @vuese
// Zarządzanie załącznikiem przypisanym do ustawienia
// @group Attachment
export default {
  components: { FileUpload, PostForm },
  mixins: [notificationsMixin],
  computed: {
    ...mapState({
      attachment: state => state.setting.attachment.list[0]
    }),
    downloadLink() {
      return `${config.mediaURL}/${this.attachment?.mediaId}`;
    }
  },

  methods: {
    // @vuese
    // Zapisuje załącznik
    saveAttachment(file) {
      if (this.attachment) {
        this.updateAttachment(file);
      } else {
        this.addNewAttachment(file);
      }
    },
    // @vuese
    // Dodaje nowy załącznik
    addNewAttachment(file) {
      const attachment = {
        mediaId: file.id,
        entityType: EntityType.SETTING,
        entityId: this.$route.params.settingId.toString(),
        name: file.name,
        type: AttachmentType.UPLOADED
      };
      this.$store
        .dispatch('setting/attachment/add', attachment)
        .then(() => this.notifySuccess(Successes.ATTACHMENT_SAVED))
        .catch(() => this.notifyError(Errors.ATTACHMENT_CANNOT_SAVE));
    },
    // @vuese
    // Aktualizuje załącznik
    updateAttachment(file) {
      this.$store
        .dispatch('setting/attachment/update', { ...this.attachment, mediaId: file.id })
        .then(() => this.notifySuccess(Successes.ATTACHMENT_SAVED))
        .catch(() => this.notifyError(Errors.ATTACHMENT_CANNOT_SAVE));
    }
  }
};
</script>
